/**
 * Ziyaret Raporu Özet — ZIYARET_TAKIP.md §5.4.
 *
 * Mevcut klasik raporun birebir karşılığı; <span class="reptag">YENİ</span> etiketli satır ve
 * kolonlar bu çalışmayla eklenenlerdir (gün özeti bloğu, başarılı/başarısız kırılımı, DBS,
 * uyum metrikleri). Yazdırılabilir — @media print kuralları visitTracking.css'te.
 */

import { fmtDate, fmtMinutes, fmtMoney, fmtNum, fmtPct, fmtTime } from './shared';
import { IcExcel, IcPrint } from './icons';

export function ReportTab({ report, loading, filters, onExcel }) {
  if (loading) {
    return <div className="pane on"><div className="card" style={{ padding: 28, textAlign: 'center' }}>Yükleniyor…</div></div>;
  }
  if (!report) {
    return (
      <div className="pane on">
        <div className="card" style={{ padding: 28, textAlign: 'center', color: 'var(--t3)' }}>
          Seçilen aralıkta veri yok.
        </div>
      </div>
    );
  }

  const d = report.daySummary || {};
  const v = report.visits || {};
  const c = report.collection || {};
  const comp = report.compliance || {};

  return (
    <div className="pane on">
      <div className="alert info m" style={{ marginBottom: 12 }}>
        <div>
          Mevcut raporun birebir karşılığı — <span className="reptag">YENİ</span> etiketli satır ve
          kolonlar bu çalışmayla eklenenlerdir.
        </div>
      </div>

      <div className="card">
        <div className="sec-h" style={{ padding: '14px 16px 0', marginBottom: 6 }}>
          <div>
            <b>Ziyaret Raporu Özet</b>
            <span className="sub" style={{ display: 'block' }}>Yazdırılabilir · Excel dışa aktarım</span>
          </div>
          <div style={{ flex: 1 }} />
          <button type="button" className="btn sec sm" onClick={() => window.print()}>
            <IcPrint size={15} />Yazdır
          </button>
          <button type="button" className="btn sec sm" onClick={onExcel}><IcExcel size={15} />Excel</button>
        </div>

        <div className="rep">
          <div className="rephead">
            <div>
              <div><span className="k">Dönem:</span><b>{fmtDate(filters.dateFrom)} – {fmtDate(filters.dateTo)}</b></div>
              <div style={{ marginTop: 6 }}>
                <span className="k">Temsilci:</span>
                <b>{filters.representativeLabel || `${report.representativeCount} temsilci`}</b>
              </div>
            </div>
            <div>
              <div><span className="k">Gün kaydı:</span><b>{fmtNum(report.sessionCount)}</b></div>
              <div style={{ marginTop: 6 }}>
                <span className="k">Distribütör:</span><b>{filters.vendorLabel || 'Tümü'}</b>
              </div>
            </div>
          </div>

          {/* Gün Özeti — bu çalışmayla EKLENEN blok */}
          <table className="reptbl">
            <tbody>
              <tr>
                <th className="l" style={{ width: 190 }}>Gün Özeti <span className="reptag">YENİ</span></th>
                <th>Güne Başlama</th><th>Günü Bitirme</th><th>Çalışma Süresi</th>
                <th>Ziyaret Süresi</th><th>Yol Süresi</th><th>Ort. Ziyaret Süresi</th>
              </tr>
              <tr>
                <td className="l">Değer</td>
                <td className="new">{fmtTime(d.startedAt)}</td>
                <td className="new">{fmtTime(d.endedAt)}</td>
                <td className="new">{fmtMinutes(d.totalWorkMin)}</td>
                <td className="new">{fmtMinutes(d.totalVisitMin)}</td>
                <td className="new">{fmtMinutes(d.totalTravelMin)}</td>
                <td className="new">{d.avgVisitMin != null ? `${d.avgVisitMin} dk` : '—'}</td>
              </tr>
            </tbody>
          </table>

          {/* Ziyaret kırılımı */}
          <table className="reptbl">
            <tbody>
              <tr>
                <th className="l" style={{ width: 190 }} />
                <th>Müşteri Sayısı</th><th>Gidilen Nokta</th><th>Ziyaret Sayısı</th>
                <th>Başarılı <span className="reptag">YENİ</span></th>
                <th>Başarısız <span className="reptag">YENİ</span></th>
                <th>Başarı % <span className="reptag">YENİ</span></th>
              </tr>
              <VisitRow label="Rut İçi" b={v.inRoute} />
              <VisitRow label="Rut Dışı" b={v.offRoute} />
            </tbody>
          </table>

          {/* Belge kırılımı */}
          <table className="reptbl">
            <tbody>
              <tr>
                <th className="l" style={{ width: 190 }} rowSpan={2} />
                <th className="grp" colSpan={3}>FATURA</th>
                <th className="grp" colSpan={3}>İRSALİYE</th>
                <th className="grp" colSpan={3}>SİPARİŞ</th>
              </tr>
              <tr>
                <th>Toplam Tutar</th><th>Adedi</th><th>Çeşit</th>
                <th>Toplam Tutar</th><th>Adedi</th><th>Çeşit</th>
                <th>Toplam Tutar</th><th>Adedi</th><th>Çeşit</th>
              </tr>
              <DocRow label="Rut İçi" report={report} key1="inRoute" />
              <DocRow label="Rut Dışı" report={report} key1="offRoute" />
            </tbody>
          </table>

          {/* Tahsilat kırılımı */}
          <table className="reptbl">
            <tbody>
              <tr>
                <th className="l" style={{ width: 190 }} />
                <th>Toplam Tahsilat</th><th>Nakit</th><th>Çek</th><th>Senet</th>
                <th>Kredi Kartı</th><th>DBS <span className="reptag">YENİ</span></th>
              </tr>
              <CollRow label="Rut İçi" b={c.inRoute} />
              <CollRow label="Rut Dışı" b={c.offRoute} />
            </tbody>
          </table>

          {/* Uyum metrikleri — YENİ satırlar işaretli */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 22 }}>
            <table className="reptbl">
              <tbody>
                <tr><th className="l" style={{ width: 190 }}>Uyum</th><th>Değer</th></tr>
                <tr><td className="l">Zamana Uymama</td><td>{fmtNum(comp.timeViolationCount)}</td></tr>
                <tr><td className="l">Toplam KM</td><td>{fmtMoney(comp.totalKm, 0)}</td></tr>
                <tr>
                  <td className="l">GPS Mesafe Aşımı <span className="reptag">YENİ</span></td>
                  <td className="new">{fmtNum(comp.outOfRadiusCount)}</td>
                </tr>
              </tbody>
            </table>
            <table className="reptbl">
              <tbody>
                <tr><th className="l" style={{ width: 190 }}>Kalite</th><th>Değer</th></tr>
                <tr>
                  <td className="l">Kısa Ziyaret <span className="reptag">YENİ</span></td>
                  <td className="new">{fmtNum(comp.shortVisitCount)}</td>
                </tr>
                <tr>
                  <td className="l">Satmama Nedeni Girilmiş <span className="reptag">YENİ</span></td>
                  <td className="new">
                    {fmtNum(comp.noSaleWithReasonCount)} / {fmtNum(comp.noSaleVisitCount)}
                  </td>
                </tr>
                <tr><td className="l">Gün kaydı</td><td>{fmtNum(report.sessionCount)}</td></tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

function VisitRow({ label, b }) {
  return (
    <tr>
      <td className="l">{label}</td>
      <td>{fmtNum(b?.customerCount)}</td>
      <td>{fmtNum(b?.visitedPointCount)}</td>
      <td>{fmtNum(b?.visitCount)}</td>
      <td className="new">{fmtNum(b?.successCount)}</td>
      <td className="new">{fmtNum(b?.failCount)}</td>
      <td className="new">{fmtPct(b?.successPct)}</td>
    </tr>
  );
}

function DocRow({ label, report, key1 }) {
  const cells = ['invoice', 'dispatch', 'order'].flatMap((k) => {
    const b = report[k]?.[key1];
    return [fmtMoney(b?.amount), fmtNum(b?.count), fmtNum(b?.skuCount)];
  });
  return (
    <tr>
      <td className="l">{label}</td>
      {cells.map((c, i) => <td key={i}>{c}</td>)}
    </tr>
  );
}

function CollRow({ label, b }) {
  return (
    <tr>
      <td className="l">{label}</td>
      <td>{fmtMoney(b?.total)}</td>
      <td>{fmtMoney(b?.cash)}</td>
      <td>{fmtMoney(b?.cheque)}</td>
      <td>{fmtMoney(b?.note)}</td>
      <td>{fmtMoney(b?.card)}</td>
      <td className="new">{fmtMoney(b?.dbs)}</td>
    </tr>
  );
}
